export const asyncRouter = {
  "/contentManage/mediaResource": () =>
    import("@/views/contentManage/mediaResource"),
  "/contentManage/genreManage": () =>
    import("@/views/contentManage/genreManage"),
  "/contentStorage/diversityManage": () =>
    import("@/views/contentStorage/diversityManage"),
  "/contentManage/artistManage": () =>
    import("@/views/contentManage/artistManage"),
  "/contentManage/mediaLibraryManage": () =>
    import("@/views/contentManage/mediaLibraryManage"),
  "/contentStorage/fileManage": () =>
    import("@/views/contentStorage/fileManage"),
  "/contentStorage/materialManage": () =>
    import("@/views/contentStorage/materialManage"),
  "/contentStorage/injectManage": () =>
    import("@/views/contentStorage/injectManage"),
  "/contentStorage/injectSeries": () =>
    import("@/views/contentStorage/injectSeries"),
  "/contentStorage/timingList": () =>
    import("@/views/contentStorage/timingList"),
  "/contentStorage/media": () => import("@/views/contentStorage/media"),
  "/contentStorage/cdnManage": () => import("@/views/contentStorage/cdnManage"),
  "/contentStorage/soldOut": () => import("@/views/contentStorage/soldOut"),
  "/ip_media/china_entity": () => import("@/views/ip_media/china_entity"),
  "/ip_media/purchase": () => import("@/views/ip_media/purchase"),
  "/ip_media/sale": () => import("@/views/ip_media/sale"),
  "/ip_media/search": () => import("@/views/ip_media/search"),
  "/ip_media/partnerManage": () => import("@/views/ip_media/partnerManage"),
  "/ip_media/rightDetail": () => import("@/views/ip_media/rightDetail"),
  "/ip_media/productDetail": () => import("@/views/ip_media/productDetail"),
  "/ip_media/product_list": () => import("@/views/ip_media/product_list"),
  "/ip_design/property2": () => import("@/views/ip_design/property2"),
  "/ip_design/ip_sale": () => import("@/views/ip_design/ip_sale"),
  "/ip_design/dispute": () => import("@/views/ip_design/dispute"),
  "/ip_design/projects": () => import("@/views/ip_design/projects"),
  "/ip_design/projects_changes": () => import("@/views/ip_design/projects_changes"),
  "/partner/company": () => import("@/views/partner/company"),
  "/partner/ems": () => import("@/views/partner/ems"),
  "/partner/contact": () => import("@/views/partner/contact"),
  "/permission/page": () => import("@/views/permission/page"),
  "/permission/role": () => import("@/views/permission/role"),
  "/permission/user": () => import("@/views/permission/user"),
  "/permission/department": () => import("@/views/permission/department"),
  "/origin/diskFlow": () => import("@/views/origin/diskFlow"),
  "/origin/licenseFlow": () => import("@/views/origin/licenseFlow"),
  "/origin/video": () => import("@/views/origin/video"),
  "/ip_design/ip": () => import("@/views/ip_design/ip"),
  "/datalake/ranks": () => import("@/views/datalake/ranks"),
  "/datalake/media": () => import("@/views/datalake/media"),
  "/datalake/project": () => import("@/views/datalake/project"),
  "/datalake/project_changes": () => import("@/views/datalake/project_changes"),
  "/filmBiz/projectFilm": () => import("@/views/filmBiz/projects"),
  "/filmBiz/projectFilm_changes": () => import("@/views/filmBiz/projects_changes"),
  "/platformManage/program": () => import("@/views/platformManage/programManage"),
  "/platformManage/entity": () => import("@/views/platformManage/entity"),
  "/stationsManage/stationsList": () => import("@/views/stationsManage/stationsList"),
  "/stationsManage/transcodeParamList": () => import("@/views/stationsManage/transcodeParamList"),
  "404": () => import("@/views/error-page/404")
};
